import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 w-full border-t border-background-200/80 bg-secondary-100/60">
      <div className="grid grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-circle-line text-xl" />
            </span>
            <span className="font-heading text-xl font-extrabold text-foreground-950">快猫</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
            快猫是多元娱乐内容与最新资讯聚合平台，覆盖影视、音乐与动态资讯，帮助你快速发现值得一看一听的精彩内容。
          </p>
        </div>
        <div>
          <h4 className="font-label text-sm font-bold text-foreground-950">内容导航</h4>
          <ul className="mt-4 space-y-2 text-sm text-foreground-700">
            <li>
              <Link to="/category/film" className="hover:text-primary-600">
                影视分类
              </Link>
            </li>
            <li>
              <Link to="/category/music" className="hover:text-primary-600">
                音乐分类
              </Link>
            </li>
            <li>
              <Link to="/category/news" className="hover:text-primary-600">
                动态资讯
              </Link>
            </li>
            <li>
              <Link to="/category" className="hover:text-primary-600">
                分类汇总
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-label text-sm font-bold text-foreground-950">关于我们</h4>
          <ul className="mt-4 space-y-2 text-sm text-foreground-700">
            <li>
              <Link to="/about" className="hover:text-primary-600">
                品牌介绍
              </Link>
            </li>
            <li>
              <Link to="/search" className="hover:text-primary-600">
                内容搜索
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-primary-600">
                联系方式
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-3 border-t border-background-200/80 px-4 py-5 text-xs text-foreground-600 sm:flex-row md:px-8">
        <p>© {new Date().getFullYear()} 快猫 KUAIMAO · 多元娱乐内容与最新资讯聚合平台</p>
        <p>本站内容均为演示样例，仅用于产品展示</p>
      </div>
    </footer>
  );
}